import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=22d41af7&scoped=true&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=22d41af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d41af7",
  null
  
)

export default component.exports